/* ==========================================================================
   TBO hero 500 - cutout fallback detector.
   Split out of sections/tbo-hero-500.liquid on 11 Sep 2026 (v8). It contains
   no Liquid, so it belongs in a cached asset rather than inline on every
   homepage load. Loaded from that section. Delete the script tag there to
   disable it; the server-side verdicts in the section keep working without it.

   WHY THE SERVER DECIDES, AND THIS IS ONLY A FALLBACK (11 Sep 2026).
   This detector loads its own Image with crossOrigin set and reads it through
   a canvas. On Safari an image already in the HTTP cache from a NON-CORS
   request gets reused for the CORS request, the canvas is tainted,
   getImageData throws, the catch below returns false, and a perfectly good
   cutout falls back to the white-card default. It is a cache-state race, so
   it hits different bottles on different devices and never reproduces in a
   fresh browser - which is why it passed QA and broke on Niko's phone, with
   the Fosforo mezcal alone in a white card while the other three floated.
   So anything verifiable is verified once at build time and marked in Liquid;
   this only runs for images nobody has checked.
   ========================================================================== */
(function () {
  /* Fallback only. Cards already marked data-tbo-cutout in Liquid are skipped
     entirely - see the v7 note in the header for why the server-side verdict
     has to win on Safari. This runs for images nobody has verified, e.g. an
     override URL or a bottle swapped in through the theme editor. */
  var KEY = 'tbo_cutout_v3';
  function cache() {
    try { return JSON.parse(window.sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function remember(store) {
    try { window.sessionStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {}
  }

  function sample(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      var done = false;
      var timer = window.setTimeout(function () { if (!done) { done = true; resolve(false); } }, 6000);
      img.onerror = function () { if (!done) { done = true; window.clearTimeout(timer); resolve(false); } };
      img.onload = function () {
        if (done) return;
        done = true;
        window.clearTimeout(timer);
        try {
          var c = document.createElement('canvas');
          c.width = img.naturalWidth;
          c.height = img.naturalHeight;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(img, 0, 0);
          var W = c.width, H = c.height;
          var d = x.getImageData(0, 0, W, H).data;
          /* Whole 2px border ring, not a handful of points. Sampling 8 points
             and demanding all 8 be clear rejected three of four real cutouts,
             because a bottle or its shadow routinely touches an edge midpoint.
             Measured: genuine cutouts 0.90-1.00, opaque photos 0.00. */
          var border = 0, clear = 0;
          for (var yy = 0; yy < H; yy++) {
            for (var xx = 0; xx < W; xx++) {
              if (xx < 2 || yy < 2 || xx >= W - 2 || yy >= H - 2) {
                border++;
                if (d[(yy * W + xx) * 4 + 3] < 16) clear++;
              }
            }
          }
          resolve(border > 0 && clear / border >= 0.85);
        } catch (e) {
          /* Tainted canvas, almost always Safari reusing a non-CORS cache
             entry. Returning false keeps the safe white-card default. */
          resolve(false);
        }
      };
      img.src = url.split('?')[0] + '?width=100';
    });
  }

  function run() {
    var cards = document.querySelectorAll('.tbo-hero5__card');
    if (!cards.length) return;
    var store = cache();
    var pending = [];
    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-tbo-cutout')) return;
      var img = card.querySelector('img');
      if (!img || !img.src) return;
      var key = img.src.split('?')[0].split('/').pop();
      if (Object.prototype.hasOwnProperty.call(store, key)) {
        if (store[key]) card.setAttribute('data-tbo-cutout', '1');
        return;
      }
      pending.push(
        sample(img.src).then(function (isCutout) {
          store[key] = isCutout;
          if (isCutout) card.setAttribute('data-tbo-cutout', '1');
        })
      );
    });
    if (pending.length) Promise.all(pending).then(function () { remember(store); });
  }

  function boot() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 1500 });
    } else {
      window.setTimeout(run, 300);
    }
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot, { once: true });
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(run, 0); });
})();
